export default "__VITE_ASSET__9e3df35a__"